<span class="badge {{ extraClasses }} {{ statusClass }}" translate>{{nominationStatus}}</span>